import React, { createContext, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { node } from 'prop-types';
import { ROUTES } from '../constants';

const defaultUser = {
  id: '',
  name: '',
  lastname1: '',
  lastname2: '',
  dni: '',
  role: '',
  login: '',
  phone: '',
  document: '',
  email: '',
  position: '',
  address: '',
};
const contextDefaultValue = {
  uniqueComplaint: false,
  getRenewPassword: null,
  getUser: null,
  setUniqueComplaint: null,
};

const SessionContext = createContext(contextDefaultValue);

/**
 * Componente que genera el Layout
 *
 * @component
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement}
 */
const SessionProvider = ({ children }) => {
  const [uniqueComplaint, setUniqueComplaint] = useState(false);
  const history = useHistory();

  const offSession = () => {
    const routes = [
      ROUTES.BACK_OFFICE,
      ROUTES.CONSULTAR_DENUNCIA,
      ROUTES.REESTABLECER_CONTRASENA,
      ROUTES.LISTADO_DENUNCIA,
    ];
    return routes.some((route) => window.location.pathname.includes(route));
  };
  const getUser = () => {
    try {
      const sessionUser = sessionStorage.getItem('user');
      if (!sessionUser) {
        if (offSession()) history.push(ROUTES.HOME);
        return defaultUser;
      }
      const userString = atob(sessionUser);
      return JSON.parse(userString);
    } catch (e) {
      console.error(e);
      return {};
    }
  };

  const getRenewPassword = () => {
    try {
      const renewPassword = sessionStorage.getItem('renewPassword');
      if (!renewPassword) {
        if (offSession()) history.push(ROUTES.HOME);
        return {};
      }
      const renewPasswordString = atob(renewPassword);
      return JSON.parse(renewPasswordString);
    } catch (e) {
      console.error(e);
      return {};
    }
  };

  const value = {
    uniqueComplaint,
    getRenewPassword,
    getUser,
    setUniqueComplaint,
  };
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
};

SessionProvider.propTypes = {
  children: node.isRequired,
};

const useSession = () => {
  const context = useContext(SessionContext);

  if (context === undefined) {
    throw new Error('useSession must be used within provider');
  }

  return context;
};

export { SessionProvider, SessionContext, useSession };
